import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import ModifyDatasourceFlagForm from './form'

const ModifyDatasourceFlagDialog = React.forwardRef(function ModifyDatasourceFlagDialog ({ config, onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource) => setDialogState({
      open: true,
      processing: false,
      dataSource
    })
  }), [setDialogState])

  return (
    <SydModal
      title={config.title}
      open={dialogState.open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <ModifyDatasourceFlagForm
            dataSource={dialogState.dataSource}
            config={config}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

ModifyDatasourceFlagDialog.propTypes = {
  config: PropTypes.shape({
    title: PropTypes.string.isRequired,
    propertyName: PropTypes.string.isRequired,
    infoText: PropTypes.string.isRequired,
    getLabel: PropTypes.func.isRequired,
    errorMessage: PropTypes.string.isRequired,
    mutationHook: PropTypes.func.isRequired,
    warningAlert: PropTypes.node
  }).isRequired,
  onComplete: PropTypes.func
}

ModifyDatasourceFlagDialog.defaultProps = {
  onComplete: () => {}
}

export default ModifyDatasourceFlagDialog
